export const homeHeroData = {
    withVideo: true,
    videoSrc: "/video/hero-video.mp4",
    imageSrc: '/images/heroBanner/GettyImages-11978838032.jpg',
    videoFallbackImage:'/images/heroBanner/HeroBannerLargeImage.webp',
    scrollTarget: 'feature-section',
    desktopHeightClass: "lg:min-h-[100vh]",
    content: {
        title: "Improve Your Sex Life with DefyED",
        description:
            "ED therapies can enhance your intimacy and boost your sexual performance, so you can get back to living your best life.",
        buttonText: { text: "Get Started", afterUpdateProfileText: "Take Questionnaire", to: "/questionnaires" },
        features: [
            { icon: '/images/icons/icon-licensed.svg', text: 'Licensed Providers' },
            { icon: '/images/icons/icon-online.svg', text: '100% online & discreet home delivery' },
            { icon: '/images/icons/icon-subscriptions.svg', text: 'Option to subscribe and save' },
            { icon: '/images/icons/icon-delivery.svg', text: 'Trimix injections available' },
        ],
    },
};

export const aboutUsHeroData = {
    withVideo: false,
    imageSrc: '/images/about-us/c9e70c63225dd4d33bbed4c2d6ce4b79.jpg',
    scrollTarget: 'about-us-feature',
    desktopHeightClass: "lg:min-h-[87vh]",
    content: {
        title: "About Us",
        description: "Defy Medical is your source for Men’s Health.",
    },
};

export const contactUsHeroData = {
    imageSrc: '/images/09c3e89c7358460c28f3fface97f7ad9.jpg',
    scrollTarget: 'contact-us-feature',
};

